module.exports = __webpack_public_path__ + "f8ea16f9037231d8a8ee5218b08990ec.jpg";